<template>
  <div
    class="py-0"
    style="z-index: 0"
    aria-label="Ir al Home, regresar a opciones de consulta y ayuda"
    v-if="currentRouteName !== 'Home'"
  >
    <v-col cols="12" class="pa-0">
      <v-row no-gutters align="center" justify="center">
        <v-col cols="3" class="ml-0 py-0">
          <v-row align="center" justify="center">
            <v-col class="px-0 pl-10">
              <v-row no-gutters align="center" justify="center">
                <v-btn
                  icon
                  to="/Procesos/Bienvenida"
                  title="Ir a Bienvenida"
                  aria-label="Ir Bienvenida"
                >
                  <v-icon>fas fa-handshake</v-icon>
                </v-btn>
                <v-btn
                  icon
                  to="/"
                  title="Ir al home"
                  aria-label="Ir al home"
                  style="visibility: hidden"
                >
                  <v-icon>fas fa-home</v-icon>
                </v-btn>
              </v-row>
            </v-col>

            <v-col cols="1" class="text-right pa-0">
              <div :style="'position: absolute;  margin-top: -16px'">
                <v-btn
                  v-if="!$route.meta.hideVolverConsulta"
                  text
                  @click="goRoute()"
                  title="Regresar a opciones de Consulta"
                  aria-label="Regresar a opciones de Consulta"
                >
                  <v-icon size="15" color="grey darken-1"
                    >fas fa-arrow-left</v-icon
                  >
                  <span class="ml-2 text-none grey--text body-2"
                    >Regresar a opciones de Consulta</span
                  >
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="6" class="text-center pa-0">
          <v-row align="center" justify="center">
            <h2
              v-if="$route.meta.hideVolverConsulta"
              :class="`${
                $vuetify.breakpoint.md ? 'title font-weight-bold' : ''
              } py-5 leading--text`"
              :style="
                $vuetify.breakpoint.mdAndUp
                  ? 'z-index: 10; position: absolute'
                  : ''
              "
            >
              Opciones de Consulta
            </h2>
          </v-row>
        </v-col>
        <v-col cols="3" class="pa-0">
          <v-row
            no-gutters
            align="center"
            justify="center"
            v-if="!$vuetify.breakpoint.xs"
          >
            <v-col cols="1" class="text-center"> </v-col>
            <v-col class="px-0">
              <v-row no-gutters align="center" justify="center">
                <v-btn
                  icon
                  :href="urlAyuda"
                  target="_Ayuda"
                  title="Ir a la Ayuda"
                  aria-label="Ir a la Ayuda"
                >
                  <v-icon>fas fa-question-circle</v-icon>
                </v-btn>
              </v-row>
            </v-col>
            <v-col cols="1" class="pr-10"> </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    //
  }),
  computed: {
    urlAyuda() {
      return this.$store.state.process.urlAyuda;
    },
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    goRoute() {
      this.$router.push("/Procesos/Index");
      this.$store.dispatch("process/clearProcesos");
      this.$store.dispatch("process/clearId");
    },
  },
};
</script>
